'use client';

import { useIsDesktop } from '@/_hooks/useBreakpoint';

import Desktop from './desktop';
import Mobile from './mobile';
import { IRedux } from '@/_store/types';
import { useDispatch, useSelector } from 'react-redux';
import { onCloseMap } from '@/_store/common/common.slice';
import { useEffect } from 'react';
import { mapDesktopLog } from './mapDesktopLog';

const Map = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();

  const { is_hall, order_type } = useSelector((state: IRedux) => state.session);
  const { isMapModal } = useSelector((state: IRedux) => state.common);

  useEffect(() => {
    const blocked = is_hall === 'true';
    mapDesktopLog('4 map-gate', {
      isMapModal,
      isDesktop,
      is_hall,
      orderType: order_type?.type ?? null,
      innerWidth: window.innerWidth,
      blocked,
      willRender: blocked ? 'null' : isDesktop ? 'DesktopDialog' : 'MobileDialog',
    });
  }, [isMapModal, isDesktop, is_hall, order_type?.type]);

  if (is_hall === 'true') {
    return null;
  }

  const commonProps = {
    open: isMapModal,
    onClose: () => {
      mapDesktopLog('8 onCloseMap');
      dispatch(onCloseMap());
    },
  };

  if (isDesktop) return <Desktop {...commonProps} />;

  return <Mobile {...commonProps} />;
};

export default Map;
